export const getInitials = (firstName: string, lastName: string) => {
  const names = [firstName, lastName];
  return names
    .map((n) => n?.[0] || "")
    .join("")
    .toUpperCase();
};
